'use strict';

import angular from 'angular';

import uiRouter from 'angular-ui-router';

import routing from './devices.routes';
import confirm from './confirm';
import list from './list'
import importDevices from './import'
import history from './history'

export default angular.module('updateServerApp.devices', [uiRouter, confirm, list, importDevices, history])
  .config(routing)
  .run(function ($rootScope) {
    'ngInject';

    $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
      if (next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
      }
    });
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/devices/index.js